<div class="pt-3" *ngIf="customerNotFound">
  <h2>Customer not found.</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="!customerNotFound && (serverError === null)">

  <div *ngIf="successMessage" class="alert alert-success text-center" role="alert">
    {{ successMessage }}
  </div>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Search by activity text"
             [(ngModel)]="filters.description_contains"
             (ngModelChange)="handleFilterChange()">
    </div>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span style="position: relative; top: -2px;">Activity Log</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Date&nbsp;/&nbsp;Time</th>
        <th scope="col">Performed By</th>
        <th scope="col">Activity</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingActivityLog">
      <tr *ngFor="let entry of activityLogList.results">
        <td>
          <span style="white-space: nowrap">{{ dateStringFromISO8601(entry.created_at) }}</span>,
          <br>
          <span style="white-space: nowrap">{{ timeStringFromISO8601(entry.created_at) }}</span>
        </td>
        <td>
          <ng-container *ngIf="entry.actor_user_id">
            {{ entry.actor_user_first_name }}
            {{ entry.actor_user_last_name}},
            <ng-container *ngIf="entry.actor_customer_id">
              Staff, on behalf of
              {{ entry.actor_customer_first_name }}
              {{ entry.actor_customer_last_name}}
            </ng-container>
            <ng-container *ngIf="entry.actor_climber_app_without_login">
              Staff, via Climber App
            </ng-container>
            <ng-container *ngIf="!entry.actor_customer_id && !entry.actor_climber_app_without_login">
              Staff
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!entry.actor_user_id">
            <ng-container *ngIf="entry.actor_customer_id">
              {{ entry.actor_customer_first_name }}
              {{ entry.actor_customer_last_name}},
              Customer
            </ng-container>
            <ng-container *ngIf="!entry.actor_customer_id">
              <ng-container *ngIf="entry.actor_climber_app_without_login">
                Non-logged in Customer
              </ng-container>
              <ng-container *ngIf="entry.actor_pos">
                Point-of-sale
              </ng-container>
              <ng-container *ngIf="!entry.actor_climber_app_without_login && !entry.actor_pos">
                <span class="text-secondary">Automatic</span>
              </ng-container>
            </ng-container>
          </ng-container>
        </td>
        <td>
          {{ entry.description }}<ng-container *ngIf="!entry.description.endsWith('.')">.</ng-container>
          <ng-container *ngIf="entry.notes">
            <br><br>
            <span class="text-muted">{{ entry.notes }}</span>
          </ng-container>
        </td>
        <td>
          <a href="#" class="edit-notes-icon"
             *ngIf="entry.actor_user_id"
             (click)="editActivityLogEntryNotes(entry);$event.preventDefault();">
            +
          </a>
        </td>
      </tr>
      <tr *ngIf="activityLogList.results.length === 0">
        <td colspan="99" class="text-muted">No activity</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingActivityLog">
      <tr>
        <td colspan="99" class="text-muted">Loading activity...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSize" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
